import React from 'react';
import {jwtDecode} from 'jwt-decode';

const Perfil = () => {
  const token = localStorage.getItem("AuthToken");

  let tokenInfo = {};
  if (token) {
    tokenInfo = jwtDecode(token);
  }

  // Si logs viene como string, se parsea; si ya es array se deja igual
  let logs = [];
  if (tokenInfo.logs) {
    try {
      // Si logs es un string, se convierte a array
      logs = typeof tokenInfo.logs === 'string'
        ? JSON.parse(tokenInfo.logs)
        : tokenInfo.logs;
    } catch (error) {
      console.error("Error al parsear logs:", error);
      logs = [];
    }
  }

  return (
    <main className='bg-gris'>
      <div className="site-width grid-perfil">
        <div className="card-perfil">
          <h2>Mi perfil</h2>
          <p>
            Conectado como <b>{tokenInfo.nombre} {tokenInfo.apellidos}</b>
          </p>

          <h4>Logs</h4>
          <p>Historial de inicios de sesión.</p>
          {logs.length > 0 ? (
          <div className="logins">
          {logs.map((log, index) => (
                <p key={index}>
                  {log.date} - {log.event}
                </p>
              ))}
            </div>
          ) : (
            <p>No hay registros de login.</p>
          )}
      </div>
       </div>
    </main>
  );
};

export default Perfil;
